<template><section>
<h1>skeleton 骨架屏</h1>
<h2>骨架屏样式组件</h2>
<p>网络请求较慢 ，文本没有加载出来时，显示文本的默认占位图。</p>
<demo-block>
                    <div class="source" slot="source">
<nt-skeleton height="200""></nt-skeleton>

</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html">
<span class="hljs-tag">&lt;<span class="hljs-name">nt-skeleton</span>  <span class="hljs-attr">height</span>=<span class="hljs-string">200</span>"&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-skeleton</span>&gt;</span>

</code></pre>
</div></demo-block>
<h2>自定义样式</h2>
<demo-block>
                    <div class="source" slot="source"><div style="display:flex">
    <nt-skeleton height="200" width="200"></nt-skeleton>
    <div style="display:flex;flex-direction:column">
        <nt-skeleton height="30"" width="200"></nt-skeleton>
        <nt-skeleton height="30"" width="400"></nt-skeleton>
        <nt-skeleton height="30"" width="400"></nt-skeleton>
        <nt-skeleton height="30"" width="400"></nt-skeleton>
    </div>
</div>

</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"display:flex"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-skeleton</span>  <span class="hljs-attr">height</span>=<span class="hljs-string">"200"</span> <span class="hljs-attr">width</span>=<span class="hljs-string">"200"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-skeleton</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"display:flex;flex-direction:column"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">nt-skeleton</span>  <span class="hljs-attr">height</span>=<span class="hljs-string">30</span>" <span class="hljs-attr">width</span>=<span class="hljs-string">"200"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-skeleton</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">nt-skeleton</span>  <span class="hljs-attr">height</span>=<span class="hljs-string">30</span>" <span class="hljs-attr">width</span>=<span class="hljs-string">"400"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-skeleton</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">nt-skeleton</span>  <span class="hljs-attr">height</span>=<span class="hljs-string">30</span>" <span class="hljs-attr">width</span>=<span class="hljs-string">"400"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-skeleton</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">nt-skeleton</span>  <span class="hljs-attr">height</span>=<span class="hljs-string">30</span>" <span class="hljs-attr">width</span>=<span class="hljs-string">"400"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-skeleton</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>width</td>
<td>占位长度</td>
<td>String</td>
<td>—</td>
<td>100%</td>
</tr>
<tr>
<td>height</td>
<td>占位宽度</td>
<td>String</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>proportion</td>
<td>高、宽比</td>
<td>Number</td>
<td>—</td>
<td>1</td>
</tr>
<tr>
<td>bgColor</td>
<td>背景色</td>
<td>String</td>
<td>—</td>
<td>'#b4bccc'</td>
</tr>
</tbody>
</table>
</section></template>

<script>

export default{

    data(){

        return {

           date:'',

           disabledDate:'2018-09-11'

        }

    }

}

</script>